import { apiClient } from './client';

/**
 * Get current mentor's profile
 * The mentor profile is its own record (bio, subject area) that exists only for
 * accounts upgraded to TEACHER: everyone else gets 404. The account's own name,
 * photo and password are edited through PATCH /users/profile and
 * POST /auth/password/change (api/users.js, api/auth.js).
 * @returns {object} Mentor profile with name, bio, subject
 */
export async function getMentorProfile() {
  const { data } = await apiClient.get('/mentor/profile');
  return data;
}

/**
 * Update current mentor's profile (TEACHER accounts only: 403 for any other role)
 * @param {object} body - name, bio, subjectArea
 */
export async function updateMentorProfile(body) {
  const { data } = await apiClient.patch('/mentor/profile', body);
  return data;
}

/**
 * Get all public mentors (directory listing)
 * GET /users takes no other filters than these: any extra query field answers 400.
 * @param {{ page?, limit?, search?, sortBy?, sortOrder? }} params
 * @returns {{ data: Array, meta: { page, limit, total, totalPages } }}
 */
export async function getPublicMentors(params = {}) {
  const { data } = await apiClient.get('/users', { params: { ...params, role: 'TEACHER' } });
  return data;
}

/**
 * Get single mentor's public profile
 * @param {string} mentorId
 */
export async function getPublicMentorProfile(mentorId) {
  const { data } = await apiClient.get(`/mentor/profile/${mentorId}`);
  return data;
}
